<template>
    <main-layout>
        <div class="background__pg-about ">
            <div class="-pt-nav">
                <SectionHeader/>
            </div>
            <div class="   -pb-xs1-4 -pb-sm-12">
                <div class="container">
                    <SectionParticipants />
                    <SectionSteps />
                </div>
                <SectionPrize />
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";

// Sections
import SectionHeader from "@/components/sections/SectionHeader";
import SectionParticipants from "@/components/sections/SectionParticipants";
import SectionSteps from "@/components/sections/SectionSteps";
import SectionPrize from "@/components/sections/SectionPrize";

export default {
    components: {
    MainLayout,
    SectionHeader,
    SectionParticipants,
    SectionSteps,
    SectionPrize,
},
    computed: {
    }
};
</script>
